class ValidationService {
  constructor(config) {
    this.config = config;
    if (typeof config.settings.uploadValidation !== "undefined") {
      let ErrorMessage0 = config.settings.uploadValidation.lang.ErrorMessage0.replace(
        "%maxMailboxJobs%",
        config.settings.uploadValidation.max_mailbox_jobs
      );
      let ErrorMessage1 = config.settings.uploadValidation.lang.ErrorMessage1.replace(
        "%maxFileUploads%",
        config.settings.uploadValidation.max_file_uploads
      );
      let inMegabyteError1 = (
        config.settings.uploadValidation.max_filesize /
        1024 /
        1024
      ).toFixed(1);
      let ErrorMessage2 = config.settings.uploadValidation.lang.ErrorMessage2.replace(
        "%inMegabyte%",
        inMegabyteError1
      );
      let ErrorMessage3 = config.settings.uploadValidation.lang.ErrorMessage3;
      let inMegabyteError4 = (
        config.settings.uploadValidation.max_filesize_total /
        1024 /
        1024
      ).toFixed(1);
      let ErrorMessage4 = config.settings.uploadValidation.lang.ErrorMessage4.replace(
        "%inMegabyte%",
        inMegabyteError4
      );
      let ErrorMessage5 = config.settings.uploadValidation.lang.ErrorMessage5;
      this.uploadValidation = {};
      this.uploadValidation["maxMailboxJobs"] =
        config.settings.uploadValidation.max_mailbox_jobs;
      this.uploadValidation["maxFileUploads"] =
        config.settings.uploadValidation.max_file_uploads;
      this.uploadValidation["maxFileSize"] =
        config.settings.uploadValidation.max_filesize;
      this.uploadValidation["maxFileSizeTotal"] =
        config.settings.uploadValidation.max_filesize_total;
      this.uploadValidation["acceptedFiles"] =
        config.settings.uploadValidation.accepted_files;
      this.uploadValidation["acceptedAttachmentFiles"] =
        config.settings.uploadValidation.accepted_attachment_files;
      this.uploadValidation["Errors"] = {
        jobType: "",
        jobCount: 0,
        countErrors: 0,
        countAccepted: 0,
        ErrorArray0: [],
        countError0: 0,
        ErrorMessage0: ErrorMessage0,
        ErrorArray1: [],
        countError1: 0,
        ErrorMessage1: ErrorMessage1,
        ErrorArray2: [],
        countError2: 0,
        ErrorMessage2: ErrorMessage2,
        ErrorArray3: [],
        countError3: 0,
        ErrorMessage3: ErrorMessage3,
        ErrorArray4: [],
        countError4: 0,
        ErrorMessage4: ErrorMessage4,
        ErrorArray5: [],
        countError5: 0,
        ErrorMessage5: ErrorMessage5
      };
    }
  }

  startValidation(jobTyp, jobCount) {
    this.uploadValidation.Errors.jobType = jobTyp;
    this.uploadValidation.Errors.jobCount = jobCount;
    this.uploadValidation.Errors.countErrors = 0;
    this.uploadValidation.Errors.countAccepted = 0;
    this.uploadValidation.Errors.ErrorArray1 = [];
    this.uploadValidation.Errors.countError1 = 0;
    this.uploadValidation.Errors.ErrorArray2 = [];
    this.uploadValidation.Errors.countError2 = 0;
    this.uploadValidation.Errors.ErrorArray3 = [];
    this.uploadValidation.Errors.countError3 = 0;
    this.uploadValidation.Errors.ErrorArray4 = [];
    this.uploadValidation.Errors.countError4 = 0;
    this.uploadValidation.Errors.ErrorArray5 = [];
    this.uploadValidation.Errors.countError5 = 0;
    return true;
  }

  getValidation() {
    return this.uploadValidation.Errors;
  }

  checkFileIsValid(file, files, type) {
    let totalFileSize = 0;
    let fileNameExists = [];
    this.uploadValidation.Errors.countAccepted = files.length;

    let newJobCount =
      this.uploadValidation.Errors.jobCount +
      this.uploadValidation.Errors.countAccepted +
      1;
    if (newJobCount > this.uploadValidation.maxMailboxJobs) {
      this.uploadValidation.Errors.countErrors++;
      this.uploadValidation.Errors.ErrorArray0.push(file.name);
      this.uploadValidation.Errors.countError0++;
      return false;
    }

    if (
      this.uploadValidation.Errors.countAccepted ===
      this.uploadValidation.maxFileUploads
    ) {
      this.uploadValidation.Errors.countErrors++;
      this.uploadValidation.Errors.ErrorArray1.push(file.name);
      this.uploadValidation.Errors.countError1++;
      return false;
    }

    if (file.size > this.uploadValidation.maxFileSize) {
      this.uploadValidation.Errors.countErrors++;
      this.uploadValidation.Errors.ErrorArray2.push(file.name);
      this.uploadValidation.Errors.countError2++;
      return false;
    }

    if (!this.isValidFile(file, type)) {
      this.uploadValidation.Errors.countErrors++;
      this.uploadValidation.Errors.ErrorArray3.push(file.name);
      this.uploadValidation.Errors.countError3++;
      return false;
    }

    $.each(files, function(index, listfile) {
      totalFileSize += listfile.size;
      if (file.name === listfile.name) {
        fileNameExists.push(file.name);
      }
    });
    totalFileSize += file.size;

    if (totalFileSize > this.uploadValidation.maxFileSizeTotal) {
      this.uploadValidation.Errors.countErrors++;
      this.uploadValidation.Errors.ErrorArray4.push(file.name);
      this.uploadValidation.Errors.countError4++;
      return false;
    }

    if (fileNameExists.length > 1) {
      this.uploadValidation.Errors.countErrors++;
      this.uploadValidation.Errors.ErrorArray5.push(file.name);
      this.uploadValidation.Errors.countError5++;
      return false;
    }

    this.uploadValidation.Errors.countAccepted++;
    return true;
  }

  isValidFile(file, type) {
    let acceptedFiles = this.uploadValidation.acceptedFiles.split(",");

    if (type == "attachment") {
      acceptedFiles = this.uploadValidation.acceptedAttachmentFiles.split(",");
    }

    let mimeType = file.type;
    let baseMimeType = mimeType.replace(/\/.*$/, "");

    for (
      var _iterator38 = acceptedFiles,
        _isArray38 = true,
        _i40 = 0,
        _iterator38 = _isArray38 ? _iterator38 : _iterator38[Symbol.iterator]();
      ;

    ) {
      let _ref35;

      if (_isArray38) {
        if (_i40 >= _iterator38.length) break;
        _ref35 = _iterator38[_i40++];
      } else {
        _i40 = _iterator38.next();
        if (_i40.done) break;
        _ref35 = _i40.value;
      }

      let validType = _ref35;
      validType = validType.trim();

      if (validType.charAt(0) === ".") {
        if (
          file.name
            .toLowerCase()
            .indexOf(
              validType.toLowerCase(),
              file.name.length - validType.length
            ) !== -1
        ) {
          return true;
        }
      } else if (/\/\*$/.test(validType)) {
        // This is something like a image/* mime type
        if (baseMimeType === validType.replace(/\/.*$/, "")) {
          return true;
        }
      } else {
        if (mimeType === validType) {
          return true;
        }
      }
    }

    return false;
  }

  validateReturnEnvelope({ returnAddress }) {
    let errorMessage = null;

    if (returnAddress.includes(","))
      errorMessage = this.config.lang[
        "modal.control.return-envelope-address-no-comma-allowed"
      ];

    if (returnAddress.length < 10 || returnAddress.search(/\n/i) === -1)
      errorMessage = this.config.lang[
        "modal.control.return-envelope-check-address"
      ];

    if (returnAddress.length < 1)
      errorMessage = this.config.lang[
        "modal.control.return-envelope-missing-address"
      ];

    return { success: !errorMessage, errorMessage };
  }
}

export default ValidationService;
